import { call, put, takeEvery } from "redux-saga/effects";
import { boMonApi } from "../../../api/category/boMonApi";
import { IIdsRequest } from "../../../model/request/IIdsRequest";
import { IBoMon } from "../../../model/respone/category/IBoMon";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eBoMonActionIds, IBoMonActionTypes } from "../../action-types/category/IBoMonActions";
import { rootActions } from "../../actions/rootActions";
const mainAction = rootActions.category.boMon;
export function* boMonSaga(): any {
  yield takeEvery(eBoMonActionIds.LOAD_START, loadWorker);
  yield takeEvery(eBoMonActionIds.SAVE_START, saveWorker);
  yield takeEvery(eBoMonActionIds.DELETE_START, deleteWorker);
}

function* loadWorker(): any {
  const res: IBaseRespone = yield call(boMonApi.SelectAll);
  if (res.is_success) {
    yield put(mainAction.LOAD_SUCCESS(res.data));
  } else {
    yield put(mainAction.LOAD_ERRR(res.message ?? "Có lỗi"));
  }
}

function* saveWorker(action: IBoMonActionTypes): any {
  let res: IBaseRespone;//= yield call(boMonApi.SelectAll);
  const payload = action.payload as IBoMon;
  if (payload.id_bm > 0) {
    res = yield call(boMonApi.Update, payload);
  } else {
    res = yield call(boMonApi.Insert, payload);
  }
  if (res.is_success) {
    yield put(mainAction.SAVE_SUCCESS(res.data));
  } else {
    yield put(mainAction.SAVE_ERRR(res.message ?? "Có lỗi"));
  }
}

function* deleteWorker(action: IBoMonActionTypes): any {
  const res: IBaseRespone = yield call(boMonApi.Deletes, action.payload as IIdsRequest);
  if (res.is_success) {
    yield put(mainAction.DELETE_SUCCESS(res.data));
  } else {
    yield put(mainAction.DELETE_ERRR(res.message ?? "Có lỗi"));
  }
}